<template>
    <section id="today" class="container">

        <b-overlay :show="loadingToday" rounded="sm">
            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <b-card-text>
                        <h4 class="text-success">Hoy</h4>
                        <h2 class="text-success"><b>{{resumeToday.transactions}}</b></h2>
                        <h4 class="text-success">Transactions</h4>
                    </b-card-text>
                </b-card>
                <b-card border-variant="success" align="center">
                    <b-card-text>
                        <h4 class="text-success">Hoy</h4>
                        <h2 class="text-success"><b>${{resumeToday.grossRevenue}} {{resumeToday.currencyBase}}</b></h2>
                        <h4 class="text-success">Gross Revenue</h4>
                    </b-card-text>
                </b-card>
                <b-card border-variant="success" align="center">
                    <b-card-text>
                        <h4 class="text-success">Hoy</h4>
                        <h2 class="text-success"><b>${{resumeToday.netRevenue}} {{resumeToday.currencyBase}}</b></h2>
                        <h4 class="text-success">Net Revenue</h4>
                    </b-card-text>
                </b-card>
                <b-card border-variant="success" align="center">
                    <b-card-text>
                        <h4 class="text-success">Hoy</h4>
                        <h2 class="text-success"><b>{{resumeToday.cutoffAverage}} Days</b></h2>
                        <h4 class="text-success">Avg Cutoff</h4>
                    </b-card-text>
                </b-card>

            </b-card-group>
        </b-overlay>

        <div class="container mt-1">
            <div class="alert alert-info text-center">
                <b>Información dinamica controlada por el formulario principal</b>
            </div>
            <b-overlay :show="loadingResumeTotals" rounded="sm">
                <b-form-row>
                    <b-col class="col-10 offset-1">
                        <b-table striped hover :items="itemsTable" :fields="fieldsTable"  :head-variant = "headerVariant"></b-table>
                    </b-col>
                </b-form-row>
            </b-overlay>
            <b-form-row>
                <b-form-group class="col-md-2" label="Mostrando:">
                    <select v-model="customFiltersVars.revenueType" @change="triggerSearchLocal++">
                        <option value="gross-revenue">Gross Revenue</option>
                        <option value="net-revenue">Net Revenue</option>
                    </select>
                </b-form-group>
            </b-form-row>
            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartTransactionsPerChannel v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartTransactionsPerChannel>
                </b-card>
            </b-card-group>

            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartRevenuePerStatus v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartRevenuePerStatus>
                </b-card>
                <b-card border-variant="success" align="center">
                    <ChartPerSalesChannel v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartPerSalesChannel>
                </b-card>
            </b-card-group>
            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartRevenuePerAirport v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartRevenuePerAirport>
                </b-card>
                <b-card border-variant="success" align="center">
                    <ChartRevenuePerVehicle v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartRevenuePerVehicle>
                </b-card>
            </b-card-group>

            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartRevenuePerSupplier v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartRevenuePerSupplier>
                </b-card>
                <b-card border-variant="success" align="center" v-if="false">
                    <ChartRevenuePerMonth v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartRevenuePerMonth>
                </b-card>
            </b-card-group>

            <b-card-group deck>
                <b-card border-variant="success" align="center">
                    <ChartCutoffWindow v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartCutoffWindow>
                </b-card>
                <b-card border-variant="success" align="center">
                    <ChartRevenuePerTripType v-if="loaded" :filters="filtersLocal" :triggerSearch="triggerSearchLocal"></ChartRevenuePerTripType>
                </b-card>
            </b-card-group>
        </div>
    </section>
</template>

<script>
    import api from '../../../../api.js'
    import ChartTransactionsPerChannel from '../charts/comercial/TransactionsPerSalesChannel'
    import ChartPerSalesChannel from '../charts/comercial/RevenuePerSalesChannel'
    import ChartRevenuePerAirport from '../charts/comercial/RevenuePerAirport'
    import ChartRevenuePerVehicle from '../charts/comercial/RevenuePerVehicle'
    import ChartRevenuePerSupplier from '../charts/comercial/RevenuePerSupplier'
    import ChartRevenuePerMonth from '../charts/comercial/RevenuePerMonth'
    import ChartRevenuePerTripType from '../charts/comercial/RevenuePerTripType'
    import ChartRevenuePerStatus from '../charts/comercial/RevenuePerStatus'
    import ChartCutoffWindow from '../charts/comercial/RidesPerCutoffWindow'

    export default {
        name: "Comercial",
        components:{ChartTransactionsPerChannel,ChartPerSalesChannel,ChartRevenuePerAirport,ChartRevenuePerVehicle,ChartRevenuePerSupplier,ChartRevenuePerMonth,ChartRevenuePerTripType,ChartRevenuePerStatus,ChartCutoffWindow},
        props:{
            filters: {
                type : Object,
                required: true
            },
            triggerSearch:{
                type : Number,
                required: true
            }
        },
        data(){
            return {
                loaded: false,
                loadingToday:false,
                loadingResumeTotals:false,
                resumeToday:{
                    currencyBase:"",
                    transactions:0,
                    grossRevenue:0,
                    cutoffAverage:0
                },
                customFiltersVars:{
                    revenueType:"gross-revenue"
                },
                triggerSearchLocal:0,
                fieldsTable: [
                    {key: 'channelTotal',label:'Total Cuentas',class:'text-center'},
                    {key: 'channelActives',label:'Cuentas activas',class:'text-center'},
                    {key: 'airportsTotal',label:'Total aeropuertos',class:'text-center'},
                    {key: 'airportsActives',label:'Aeropuertos activos',class:'text-center'},
                    {key: 'suppliersTotal',label:'Total proveedores',class:'text-center'},
                    {key: 'suppliersActives',label:'Proveedores activos',class:'text-center'},
                ],
                itemsTable:[
                    { channelTotal: 0, channelActives: 0, airportsTotal: 0, airportsActives: 0,suppliersTotal:0,suppliersActives:0 }
                ],
                headerVariant:"light",
            }
        },
        methods:{
            getResumeToday(){
                this.loadingToday = true;
                return api(this).get(`/dashboard/comercial/resume`).then((res) => {
                    this.resumeToday = res.data;
                }).catch(this.handleModelError).finally(()=>{
                    this.loadingToday=false;
                })
            },
            getResumeTotals(){
                this.loadingResumeTotals = true;
                return api(this).get(`/dashboard/comercial/resumeTotals`,{params: {filters:this.filtersLocal}}).then((res) => {
                    this.itemsTable = res.data.items;
                }).catch(this.$root.handleRequestError).finally(()=>{
                    this.loadingResumeTotals=false;
                })
            }
        },
        mounted(){
            this.triggerSearchLocal = this.triggerSearch;
            this.getResumeToday()
                .finally(this.getResumeTotals)
                .finally(()=>this.loaded=true)
        },
        computed:{
            filtersLocal:function () {
                return Object.assign({},this.filters,this.customFiltersVars);
            },
        },
        watch:{
            triggerSearch(){
                this.getResumeTotals();
                this.triggerSearchLocal = this.triggerSearch;
            }
        }
    }
</script>

<style scoped>

</style>
